import SometimesRock from "../images/Sometimes_Rock.webp";
import SuburbanRide from "../images/Suburban_Ride.webp";
import StrangeWay from "../images/Strange_Way_To_Know_Me.webp";

export const singles = [
  {
    id: "sometimes-rock",
    title: "Sometimes Rock",
    month: "02",
    year: "2025",
    cover: SometimesRock,
    links: {
      spotify: "https://open.spotify.com/track/FAKE1",
      apple: "https://music.apple.com/track/FAKE1",
      youtube: "https://youtube.com/watch?v=FAKE1",
    },
  },
  {
    id: "suburban-ride",
    title: "Suburban Ride",
    cover: SuburbanRide,
    month: "12",
    year: "2023",
    links: {
      spotify: "https://open.spotify.com/track/FAKE2",
      apple: "https://music.apple.com/track/FAKE2",
      youtube: "https://youtube.com/watch?v=FAKE2",
    },
  },
  {
    id: "strange-way",
    title: "Strange Way To Know Me",
    cover: StrangeWay,
    month: "11",
    year: "2023",
    links: {
      spotify: "https://open.spotify.com/track/FAKE3",
      apple: "https://music.apple.com/track/FAKE3",
      youtube: "https://youtube.com/watch?v=FAKE3",
    },
  },
];
